import React from 'react'
import BooleanIcon from 'UI/BooleanIcon'

const booleanIcon = (data, falseIcon = 'minus') => (
  <BooleanIcon {...{ booleanValue: data.value, falseIcon: { icon: falseIcon }, styles: { color: data.value ? 'green': 'grey' } }} />
)
const columns = [
  { Header: 'Location', accessor: 'location' },
  { Header: 'Site', accessor: 'site_code' },
  { Header: 'Network range', accessor: 'network_range' },
  { Header: 'First usable IP', accessor: 'first_usable_ip' },
  { Header: 'Last usable IP', accessor: 'last_usable_ip' },
  { Header: 'Broadcast Address', accessor: 'broadcast_address' },
  { Header: 'Total Addresses', accessor: 'total_addresses' },
  { Header: 'Assigned', accessor: 'assigned' },
  { Header: 'Unassigned', accessor: 'unassigned' },
]

const subTableColumns = [
  { Header: 'IP Address', accessor: 'ip_address' },
  { Header: 'Client', accessor: 'client_name' },
  { Header: 'Allocated to', accessor: 'allocated_to' },
  { Header: 'System', accessor: 'system' },
  { Header: 'Ports', accessor: 'ports' },
  { Header: 'Protocol', accessor: 'procotol' },
  { Header: 'Service', accessor: 'service' },
  { Header: 'Shodan response', accessor: 'in_shodan', Cell: (data) => booleanIcon(data) },
  { Header: 'Vulnerability score', accessor: 'vulnerability_score' },
  { Header: 'Has a cert', accessor: 'has_cert', Cell: (data) => booleanIcon(data) },
  { Header: 'Has expired', accessor: 'expired', Cell: (data) => (
    data.original.has_cert ? (
      <BooleanIcon {...{ booleanValue: !data.value, styles: { color: data.value ? 'red' : 'green' } }} />
    ) : (
      <BooleanIcon {...{ booleanValue: false, falseIcon: { icon: 'minus' }, styles: { color: 'grey' } }} />
    ))
  },
  { Header: 'Expiry date', accessor: 'expiry_date' },
]

export { columns, subTableColumns }